<template>
  <v-row class="pl-3 pr-3 align-center">
    <div class="manage-department-title">
    {{titlename}}
  </div>
  <v-btn
    v-if="btnDel"
    class="ml-5"
    elevation="2"
    dark fab small
    color="red"
    @click="deleteOrgchart"
  >
    <v-icon dark>
      far fa-trash-alt
    </v-icon>
  </v-btn>
  </v-row>
</template>

<script>
import { EventBus } from '@/EventBus'

export default {
  name: 'template-title-orgchart',
  props: {
    titlename: String,
    btnDel: Boolean
  },
  methods: {
    deleteOrgchart () {
      EventBus.$emit('updateOrgchart-deleteOrgchart')
    }
  }
}
</script>
